<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
        <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
             <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
            <b-col>
                <h1>{{ecmResourceStrings.ttlExecutionDetails}} '{{partitiondescription}}'</h1>
            </b-col>
            <b-col class="text-right OTbtnContainer">
                <otif-button class="OTSecondary"  @click.native="back" id="backtoexec" :title="ecmResourceStrings.tipBackToExec" >{{ecmResourceStrings.lblBack}}</otif-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col >
                <otif-ecm-table-info
                    ref="table"
                    :sortCallback="sort"
                    :paginated="false"
                    :totalRowsCallback="totalRows"
                    :rows="logData"
                    :columns="columns">
                    <template slot="empty">
                       {{ecmResourceStrings.msgNoInfo}}
                    </template>
                </otif-ecm-table-info>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import ecmRepositoryDefinition from '@/ecm/collections/ecmrepodefinitions.js';
import { sortOn } from '../../../utils/commonECM.js';
import axios from 'axios';
import ExceptionColumn from '../../links/testconnectionexception.vue';
import { showMessage} from '../../../utils/commonECM.js';
import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';


export default {

    props: ['logid','ecmrepositorytype', 'ecmrepositoryid', 'partitiondescription', 'partitionid', 'col'],
  
    data() {
        return {
            ecmResourceStrings: require('../../../utils/resourceECM.js'),  
            messageDlg:false,
            logData : null,//contains all data
            columns: [
            {
                name: 'logId',
                label: 'Log ID',
                sortable: true,
                editable:false,
                width:'10%',
                render(row) {
                    return row.logId;
                }
            },{
                name: 'processName',
                label: 'Process Name',
                sortable: true,
                editable:false,
                render(row) {
                    return row.processName;
                }
            },{
                name: 'runningContextName',
                label: 'Running Context',
                sortable: true,
                editable:false,
                render(row) {
                    return row.runningContextName;
                }
            },{
                name: 'startDate',
                label: 'Start Time',
                sortable: true,
                editable:false,
                render(row) {
                    return row.startDate;
                }
            },{
                name: 'endDate',
                label: 'End Time',
                sortable: true,
                editable:false,
                render(row) {
                    return row.endDate;
                }
            },{
                name: 'status',
                label: 'Status',
                sortable: true,
                editable:false,
                render(row) {
                    return row.status;
                }
            },{
                name: 'parentProcessId',
                label: 'Parent Log ID',
                width:'10%',
                sortable: true,
                editable:false,
                render(row) {
                    return row.parentProcessId;
                }
            },{
                name: 'exceptionsfull',
                label: 'Exceptions',
                sortable: false,
                editable:false,
                displayComponent:ExceptionColumn,
            }],
            loaded: false
        }
    },

    methods: {
        refresh(){
            this.loaded = true;
        },

        sort(colNumber, dir) {
            var that = this;
            that.sortDir = dir;
            if(colNumber == 0)
                that.logData.sort(sortOn('logId', dir));
            else if(colNumber == 1)
                that.logData.sort(sortOn('processName', dir));
            else if(colNumber == 2)
                that.logData.sort(sortOn('runningContextName', dir));
            else if(colNumber == 3)
                that.logData.sort(sortOn('startDate', dir));
            else if(colNumber == 4)
                that.logData.sort(sortOn('endDate', dir));
            else if(colNumber == 5)
                that.logData.sort(sortOn('status', dir));
            else if(colNumber == 6)
                that.logData.sort(sortOn('parentProcessId', dir));
        },
        totalRows() {
            return this.config.length;
        },

        showException(row){
            var that = this;
            if(row.exceptionsfull)
            {
                showMessage(this, 'info', that.ecmResourceStrings.ttlExceptions,'', true, row.exceptionsfull);
            }
        },

        back(){
            if(this.ecmrepositorytype =="dbms_generic_v1")
            {
                const data = encodeURIComponent(this.ecmrepositorytype) + "/" + encodeURIComponent(this.ecmrepositoryid) + "/" + encodeURIComponent(this.partitiondescription) + "/" + encodeURIComponent(this.partitionid) + "/" + encodeURIComponent(this.col);
                this.$router.push('/reports/rdbmscrawlerexecutions/rdbmspartitionexecutiondetails/'+ data);
            }
            else{
                const data = encodeURIComponent(this.ecmrepositorytype) + "/" + encodeURIComponent(this.ecmrepositoryid) + "/" + encodeURIComponent(this.partitiondescription) + "/" + encodeURIComponent(this.partitionid) + "/" + encodeURIComponent(this.col);
                this.$router.push('/reports/ecmcrawlerexecutions/ecmpartitionexecutiondetails/'+ data);
            }
        }
    },
    
    components: {
        ECMErrorDialog
    },
    
     mounted() {
            if(this.ecmrepositorytype =="dbms_generic_v1")
            {
                var breadcrumbs = [{
                name: 'reports',
                meta: { label: 'Reports' }
                },{
                    name: 'rdbms-executions',
                    meta: { label: 'Executions' }
                },{
                    name: 'rdbmsexecutiondetails',
                    meta: { label: 'Execution Details' }
                }];

                this.$store.commit('breadcrumbs', breadcrumbs);
            }
            else
            {
                var breadcrumbs = [{
                    name: 'reports',
                    meta: { label: 'Reports' }
                },{
                    name: 'ecm-executions',
                    meta: { label: 'Executions' }
                },{
                    name: 'executiondetails',
                    meta: { label: 'Execution Details' }
                }];

                this.$store.commit('breadcrumbs', breadcrumbs);
            }
    },
   
    created() {
        var that = this;
        that.logData=[];
        const action = 'executionDetails/' + that.logid;
            axios.get('/mtm-gateway-api/v1/services/ecm/query/executionDetails/' + that.logid, 
            {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                .then((res) => {
                    if (res.data) {   
                        var otputtext='';
                        const oticExecutionDetails = res.data.oticExecutionDetails;
                        if(oticExecutionDetails)
                        {
                            const len = oticExecutionDetails.length;
                         
                            if(len!=0)
                            {
                                for(var i=0; i<len; i++)
                                {
                                    const execdetails = oticExecutionDetails[i];
                                  
                                    if(execdetails)
                                    {
                                        var logId = "";
                                        if(execdetails.logId)
                                        {
                                            logId = execdetails.logId;
                                        }
                                        var  processName = "";
                                        if(execdetails.processName)
                                        {
                                            processName = execdetails.processName;
                                        }
                                        
                                        var runningContextName = "";
                                        if (execdetails.runningContextName)
                                        {
                                            runningContextName = execdetails.runningContextName;
                                        }
                                        
                                        var startDatex = "";
                                        const sttim = execdetails.startDate;
                                        if (sttim)
                                        {
                                            const d = new Date(sttim);

                                            if(d == "Invalid Date")
                        	            	{
                        	            			startDatex = sttim.toLocaleString();
                        	            	}
                        	            	else
                        	            	{
                        	            			startDatex = d.toLocaleString(); 
                        	            	}	
                                        
                                        }
                                        
                                        var endDatex = "";
                                        const endtim = execdetails.endDate;
                                        if(endtim)
                                        {
                                            const d = new Date(endtim);
                                            
                                            if(d == "Invalid Date")
                        	            	{
                        	            			endDatex = endtim.toLocaleString();
                        	            	}
                        	            	else
                        	            	{
                        	            			endDatex = d.toLocaleString(); 
                                            }	
                                        }
                                        
                                        var parentProcessId = "";
                                        if(execdetails.parentProcessId)
                                        {
                                            parentProcessId = execdetails.parentProcessId;
                                        }
                                        
                                        var processId = "";
                                        if(execdetails.processId)
                                        {
                                            processId = execdetails.processId;
                                        }
                                        
                                        var statusx = "";
                                        if(execdetails.status)
                                        {
                                            statusx = execdetails.status;
                                        }
                                        
                                        var returnCode = "";
                                        if(execdetails.returnCode)
                                        {
                                            returnCode = execdetails.returnCode;
                                        }
                                        
                                        var exceptionsfull = "";var executionStatusCode = 0;var errordata= '';
                                        if(execdetails.exceptions)
                                        {
                                              exceptionsfull = execdetails.exceptions;
                                              executionStatusCode = 1;
                                              errordata = 'Error';
                                        }
                                        
                                        that.logData.push({"logId" : logId, "processId" : processId, "processName" : processName, "runningContextName" : runningContextName,
                                            "startDate" : startDatex, "endDate": endDatex, "returnCode" : returnCode, "status" : statusx, "parentProcessId" : parentProcessId,
                                            "exceptionsfull" : exceptionsfull , "executionStatusCode" : executionStatusCode , "errordata":errordata});
                                    }
                                }
                            }
                        }
                       that.loaded = true;
                    }
                })
                .catch((err) => {
                    that.loaded = true;
                    this.$snotify.clear();
                    if(err.message)
                    {
                        this.$snotify.error(err.message, this.ecmResourceStrings.txtError);
                    }
                    else  if(err.response)
                    {this.$snotify.error(err.response.data, this.ecmResourceStrings.txtError);
                    }
                   
                });
          
    },
}

</script>
